import styled, { css } from 'styled-components';

export const LandingPageDiv = styled.section`
  position: relative;
  height: 100vh;
  padding-top: 3rem;
  overflow: hidden;

  ${({ sideBar }) =>
    sideBar &&
    css`
      filter: blur(4px);
    `}

  @media (max-width: 900px) {
    padding-top: 3rem;
  }
  .page {
    width: calc(100% - 9rem);
    margin-left: 9rem;
    height: 100%;
    @media (max-width: 900px) {
      height: 100%;
      width: 100%;
      margin-left: 0;
    }
  }

  .tags {
    color: #3bcfe3;
    opacity: 0.3;
    margin: 2rem;
    font-size: 18px;
    font-family: 'La Belle Aurore', cursive;

    @media (max-width: 692px) {
      margin: 2rem 1rem;
    }

    @media (max-width: 395px) {
      margin: 2rem 0.1rem;
    }
  }
`;
